import axios from "../axios";
import { Cookies } from "react-cookie";
const endPoint = `/crm/actions/`;

const cookie = new Cookies();

export const createAction = async ({ name, description }) => {
  const token = cookie.get("crm");
  const res = await axios.post(
    `${endPoint}create`,
    { name, description },
    { headers: { Authorization: token } },
  );
  return res;
};

export const getActions = async (page) => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}all?page${page}`, {
    headers: { Authorization: token },
  });
  return res;
};

export const getAllActions = async () => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}all_actions`, {
    headers: { Authorization: token },
  });
  return res;
};

export const deleteActions = async ({ actions }) => {
  const token = cookie.get("crm");
  const res = await axios.put(
    `${endPoint}delete`,
    { actions },
    {
      headers: { Authorization: token },
    },
  );
  return res;
};
